import { render } from "./DocContent.vue?vue&type=template&id=1c793be3&scoped=true"
import script from "./DocContent.vue?vue&type=script&lang=js"
export * from "./DocContent.vue?vue&type=script&lang=js"

import "./DocContent.vue?vue&type=style&index=0&id=1c793be3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c793be3"]])

export default __exports__